// eslint-disable-next-line
export default '#map-container,.onekey,.js-onekey-create,.onekey-landing__split-promo,.onekey-landing__easy-to-use,.onekey-landing__what-is-onekey,.faq,.onekey-landing__tick-tiles';